import FinancingWallets from './FinancingWallets';

export default FinancingWallets;
